/* global google */
import SideBar from "../../components/layout/sidebar"
import { TimelineChart } from "../../components/layout/timeline-chart"
import styles from "./page.module.scss"
import ManageStopsModal from "../../components/modals/manage-stops"
import { useEffect, useState, useCallback, useMemo } from "react"
import ProfileModal from "../../components/modals/profile"
import {
  DirectionsRenderer,
  GoogleMap,
  Marker,
  MarkerF,
  InfoWindow
} from "@react-google-maps/api"
import { getStore, useGet } from "../../utils/functions"
import {GreenBin} from '../../components/icons/green-bin';
import {OrangeBin} from '../../components/icons/orange-bin';
import {RedBin} from '../../components/icons/red-bin';
import { useLayoutEffect } from "react"
import { addBins, addUserAuth, addZones, getBins, updateVehicleLocation } from "../../redux/authSlice"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { renderToString } from 'react-dom/server';

const HomePage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { auth, binList, markers } = useSelector(state => state.user)
  const [openModal, setOpenModal] = useState(false)
  const [openProfileModal, setOpenProfileModal] = useState(false)
  const [displayRoutes, setDisplayRoutes] = useState(true);
  const [selectedZone, setSelectedZone] = useState('All Zones');
  const [showFilledBins, setShowFilledBins] = useState(true);
  const [showNotFilledBins, setShowNotFilledBins] = useState(true);
  const [isTimelineChartVisible, setTimelineChartVisible] = useState(true);


  const vehicleLocation = useSelector(state => state.user.vehicleLocation);

  const [hide, setHide] = useState(false)

  const { fetch, fetchedData, isLoading } = useGet("userzones/")
  const token = getStore("auth")
  const getbins = useGet("getbins/")
  const bin_list = useGet("userbins/")

  // Create a mapping from zone names to ids
  const zoneNameToId = fetchedData.reduce((acc, zone) => {
    acc[zone.name] = zone.id;
    return acc;
  }, {});

  // Create a mapping from zone ids to pickup levels
  const zoneIdToPickupLevel = fetchedData.reduce((acc, zone) => {
    acc[zone.id] = zone.pickup_level;
    return acc;
  }, {});

  // Get the id of the selected zone
  const selectedZoneId = zoneNameToId[selectedZone];

  const binsWithPickupLevel = binList.map(bin => {
    const pickup_level = zoneIdToPickupLevel[bin.zone];
    return { ...bin, pickup_level };
  });

  let filteredBins = binsWithPickupLevel;
  if (selectedZone !== 'All Zones') {
    filteredBins = binsWithPickupLevel.filter(bin => bin.zone === selectedZoneId);
  }
  if (!showFilledBins) {
    filteredBins = filteredBins.filter(bin => bin.fill_level < zoneIdToPickupLevel[bin.zone]);
  }
  if (!showNotFilledBins) {
    filteredBins = filteredBins.filter(bin => bin.fill_level >= zoneIdToPickupLevel[bin.zone]);
  }

  // Filter bins to only include filled bins
  let filledBins;
  if (selectedZone === 'All Zones') {
    filledBins = binsWithPickupLevel.filter(bin => bin.fill_level >= bin.pickup_level);
  } else {
    filledBins = binsWithPickupLevel.filter(bin => bin.fill_level >= bin.pickup_level && bin.zone === selectedZoneId);
  }
  

  useLayoutEffect(() => {
    if (!token?.email) {
      navigate("/login")
    }
    dispatch(addUserAuth(token))
    fetch()
    getbins.fetch()
    bin_list.fetch()
  }, [])

  useLayoutEffect(() => {
    if (getbins.fetchedData.length > 0) {
      dispatch(addBins(bin_list.fetchedData))
      dispatch(addZones(fetchedData))
      dispatch(getBins(getbins.fetchedData))
    }
  }, [isLoading, bin_list.isLoading, getbins.isLoading, getbins.fetchedData])

  const props = {
    openModal,
    setOpenModal,
    openProfileModal,
    setOpenProfileModal,
    hide,
    setHide,
    user: auth,
    binList,
    getBins: getbins.fetchedData
  }

  return (
    <main className={`${styles.container} ${hide ? styles.hide : ""}`}>
      <SideBar {...props} displayRoutes={displayRoutes} setDisplayRoutes={setDisplayRoutes} 
      selectedZone={selectedZone} setSelectedZone={setSelectedZone} 
      showFilledBins={showFilledBins} setShowFilledBins={setShowFilledBins} 
      isTimelineChartVisible={isTimelineChartVisible} 
      setTimelineChartVisible={setTimelineChartVisible} 
      showNotFilledBins={showNotFilledBins} setShowNotFilledBins={setShowNotFilledBins} />
      <div className={styles.image}>
        {" "}
        <App bins={filteredBins} filledBins={filledBins} displayRoutes={displayRoutes} showFilledBins={showFilledBins} vehicleLocation={vehicleLocation} />
        <TimelineChart bins={filledBins} vehicleLocation={vehicleLocation}
        hide={hide} zones={fetchedData}
        isTimelineChartVisible={isTimelineChartVisible} 
        setTimelineChartVisible={setTimelineChartVisible} />     
      </div>

      <ManageStopsModal {...props} />
      <ProfileModal {...props} />
    </main>
  )
}
export default HomePage;

const App = ({ bins, filledBins, displayRoutes, showFilledBins, vehicleLocation }) => {
  const dispatch = useDispatch()
  const [map, setMap] = useState(null)
  const [center, setCenter] = useState({})
  const [renderCount, setRenderCount] = useState(0);
  const { fetchedData, isLoading, fetch } = useGet("current-location/")
  const [selectedBin, setSelectedBin] = useState(null);

  const getColorForZone = (zone) => {
    const hue = zone * 137.508; // Use golden angle to distribute colors evenly
    return `hsl(${hue}, 100%, 50%)`; // Use fixed saturation and lightness for simplicity
  };

  const containerStyle = {
    width: "100%",
    height: "100%"
  }

  const onLoad = useCallback(function callback(map) {
    if (!map) return;
    if (map !== null) {
      console.log("Map is already initialized.");
      return;
    }
    console.log("Map is initialized.");
    const bounds = new google.maps.LatLngBounds();
    bins?.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
    map?.fitBounds(bounds);
    setMap(map);
  }, []);
  const onUnmount = useCallback(function callback(map) {
    setMap(null)
  }, [])

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    if (fetchedData) {
      dispatch(updateVehicleLocation(fetchedData));
    }
  }, [fetchedData]);

  useEffect(() => {
    setRenderCount(renderCount => renderCount + 1);
  }, [bins, vehicleLocation, displayRoutes]);

  const calculatedCenter = useMemo(() => {
    if (bins.length > 0) {
      // If routes are not displayed, set the center to the average location of the bins
      const center = bins.reduce(
        (prev, bin) => {
          const acc = { ...prev };
          const lat = parseFloat(bin.latitude);
          const lng = parseFloat(bin.longitude);
          if (!isNaN(lat) && !isNaN(lng)) {
            acc.lat += lat;
            acc.lng += lng;
          }
          return acc;
        },
        { lat: 0, lng: 0 } // Initialize with lat and lng properties
      );
      const newCenter = { ...center };
      newCenter.lat /= bins.length;
      newCenter.lng /= bins.length;
      return newCenter;
    } else {
      // Set a default center when there are no bins
      return { lat: 47.560539, lng: -52.712830 };
    }
  }, [bins]);

  useEffect(() => {
    if (map) {
      if (displayRoutes) {
        const bounds = new google.maps.LatLngBounds();
        bins.forEach(({ latitude, longitude }) => {
          const lat = parseFloat(latitude);
          const lng = parseFloat(longitude);
          if (!isNaN(lat) && !isNaN(lng)) {
            bounds.extend({ lat, lng });
          }
        });
        // If routes are displayed, fit the bounds to include the routes
        map.fitBounds(bounds);
      } else {
        console.log("Setting map center: ", center);
        map.setCenter(center);
      }
      console.log("Center state is updated: ", center);
    }
  }, [map, bins, displayRoutes, center]);
  
  useEffect(() => {
    if (JSON.stringify(center) !== JSON.stringify(calculatedCenter)) {
      setCenter(calculatedCenter);
    }
  }, [calculatedCenter]);

  useEffect(() => {
    if (map && center) {
        map.setCenter(center);
        map.setZoom(12);
    }
  }, [map, center, displayRoutes]);

  const [directions, setDirections] = useState([])

  const [shouldUpdateDirections, setShouldUpdateDirections] = useState(true);

  useEffect(() => {
      setShouldUpdateDirections(true); // Reset directions state
  }, [bins, vehicleLocation]);

  useEffect(() => {
    setDirections([]);

    if (!vehicleLocation || bins.length === 0) {
      return;
    }

    const binsByZone = filledBins.reduce((acc, bin) => {
      const zone = bin.zone;
      if (!acc[zone]) {
        acc[zone] = [];
      }
      acc[zone].push(bin);
      return acc;
    }, {});
  
    const directionsService = new window.google.maps.DirectionsService();
    const origin = { lat: vehicleLocation.latitude, lng: vehicleLocation.longitude };
  
    Object.keys(binsByZone).forEach((zone, index) => {
      const bins = binsByZone[zone];
      const waypoints = bins.map(({ latitude, longitude }) => {
        return { location: { lat: parseFloat(latitude), lng: parseFloat(longitude) } };
      });
      const destination = waypoints[waypoints.length - 1].location;
      const color = getColorForZone(zone);
  
      directionsService.route(
        {
          origin: origin,
          destination: destination,
          waypoints: waypoints,
          optimizeWaypoints: true,
          travelMode: "DRIVING"
        },
        (result, status) => {
          if (status === "OK") {
            setDirections(prevDirections => [...prevDirections, { result, color }]);
          } else {
            console.error("Error fetching directions:", result);
          }
        }
      );
    });
  
  }, [vehicleLocation, bins, shouldUpdateDirections, filledBins])
  
  const getBinIcon = (fillLevel, pickupLevel) => {
    let BinIcon;
    if (fillLevel < pickupLevel / 2) {
      BinIcon = <GreenBin fill_level={fillLevel} />;
    } else if (fillLevel < pickupLevel) {
      BinIcon = <OrangeBin fill_level={fillLevel} />;
    } else {
      BinIcon = <RedBin fill_level={fillLevel} />;
    }
    return renderToString(BinIcon);
  };  

  return (
    <div className="App">
      <GoogleMap
        key={renderCount}
        mapContainerStyle={containerStyle}
        center={center}
        zoom={12}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {vehicleLocation && typeof vehicleLocation.latitude === 'number' && typeof vehicleLocation.longitude === 'number' && bins && bins.length > 0 && bins.map(({ latitude, longitude, fill_level, pickup_level }, idx) => {
          const isBinSelected = selectedBin && selectedBin.latitude === latitude && selectedBin.longitude === longitude;
          const occupiedWeight = (fill_level / pickup_level) * 1000;
          return (
            <div key={idx}>  
              <MarkerF
                icon={{
                  url:
                    "data:image/svg+xml;charset=UTF-8," +
                    encodeURIComponent(getBinIcon(fill_level, pickup_level)),
                  anchor: new window.google.maps.Point(15, 15)
                }}
                position={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }}
                animation={fill_level >= pickup_level ? window.google.maps.Animation.BOUNCE : null}
                onMouseOver={() => {
                  setSelectedBin({ latitude, longitude, fill_level, pickup_level });
                }}
                onMouseOut={() => {
                  setSelectedBin(null);
                }}
              >
                {isBinSelected && (
                  <InfoWindow
                    position={{ lat: parseFloat(selectedBin.latitude), lng: parseFloat(selectedBin.longitude) }}
                    onCloseClick={() => {
                      setSelectedBin(null);
                    }}
                  >
                    <div>
                      <p>Occupied Weight:</p>
                      <p>{occupiedWeight} kgs</p>
                    </div>
                  </InfoWindow>
                )}
              </MarkerF>
              <MarkerF
                icon={{
                  url: "/media/images/home/truck.svg",
                  // scaledSize: new window.google.maps.Size(30, 30),
                  anchor: new window.google.maps.Point(15, 15)
                }}
                position={{lat: vehicleLocation.latitude, lng: vehicleLocation.longitude}}
              ></MarkerF>
              {displayRoutes && showFilledBins && directions.map(({ result, color }, index) => (
                <DirectionsRenderer
                  key={index}
                  directions={result}
                  options={{
                    polylineOptions: {
                      strokeColor: color
                    },
                    suppressMarkers: true,
                    markerOptions: {
                      icon: {
                        url: "/static/logo/trash.svg"
                      }
                    }
                  }}
                />
              ))}
            </div>          
          );
        })}
      </GoogleMap>
    </div>
  )
  
}
